import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://innerlight-healing.co.uk";
const SUFFIX = " | Inner Light Healing";

const META = {
  "/": {
    t: "Free QHHT Sessions for Women — Devon & Cornwall",
    d: "Quantum Healing Hypnosis Technique (QHHT) sessions for women with Isabelle Legér, serving Devon & Cornwall from the South Hams near Ivybridge. Free volunteer sessions — gentle, safe and confidential.",
  },
  "/about-qhht": {
    t: "What is QHHT? Quantum Healing Hypnosis Technique",
    d: "Learn about the Quantum Healing Hypnosis Technique developed by Dolores Cannon — a gentle, guided practice for deep relaxation, insight and inner healing, offered across Devon & Cornwall.",
  },
  "/about-isabelle": {
    t: "About Isabelle Legér, QHHT Practitioner in Devon",
    d: "Meet Isabelle Legér, a Level 2 QHHT practitioner offering gentle Quantum Healing Hypnosis Technique sessions for women across Devon, Cornwall and the South Hams near Ivybridge.",
  },
  "/what-to-expect": {
    t: "What to Expect in a QHHT Session",
    d: "A relaxed, one-to-one QHHT session in the South Hams near Ivybridge — what happens, how to prepare, and what women across Devon & Cornwall can expect.",
  },
  "/volunteer": {
    t: "Free Volunteer QHHT Sessions for Women — South Hams",
    d: "Complimentary QHHT sessions for female volunteers in the South Hams near Ivybridge, serving Devon & Cornwall, as Isabelle completes her Level 2 training. Limited spaces available.",
  },
  "/faq": {
    t: "QHHT Frequently Asked Questions",
    d: "Answers to common questions about Quantum Healing Hypnosis Technique sessions in Devon & Cornwall — safety, what to expect, preparation and confidentiality.",
  },
  "/testimonials": {
    t: "Testimonials",
    d: "Reflections from women across Devon and Cornwall who have experienced a QHHT session with Isabelle Legér at Inner Light Healing, South Hams.",
  },
  "/contact": {
    t: "Contact Isabelle — QHHT in Devon & Cornwall",
    d: "Get in touch with Isabelle Legér about QHHT sessions in the South Hams near Ivybridge, serving Devon & Cornwall. Send a gentle enquiry and she will reply with care.",
  },
  "/book": {
    t: "Book a QHHT Session — Ivybridge, South Hams",
    d: "Request a Quantum Healing Hypnosis Technique session with Isabelle Legér near Ivybridge in the South Hams, serving Devon & Cornwall. Choose a preferred date and time.",
  },
};

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) {
      document.title = "Practitioner Login | Inner Light Healing";
      setMeta("name", "robots", "noindex, nofollow");
      return;
    }
    const m = META[pathname] || META["/"];
    const title = m.t + SUFFIX;
    document.title = title;
    setMeta("name", "description", m.d);
    setMeta("name", "robots", "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", m.d);
    setMeta("property", "og:url", `${SITE}${pathname}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", m.d);
    setCanonical(`${SITE}${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);

  return null;
}
